import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithInterceptor } from "src/utils/baseQuery";

export const PaymentApi = createApi({
  reducerPath: "PaymentApi",
  baseQuery: baseQueryWithInterceptor,
  tagTypes: ["Notification"],
  endpoints: (builder) => ({
    getPaymentUrl: builder.query<any, string>({
        query: (orderId) => ({
          headers: {
            "Content-type": "application/json",
          },
          url: `payment/${orderId}`,
          method: "GET",
        }),
      }),
    
  }),
});

export const {
  useLazyGetPaymentUrlQuery,
} = PaymentApi;
